import { FC, HTMLAttributes } from 'react';
import classNames from 'classnames';

type Props = HTMLAttributes<HTMLOrSVGElement>;

const ChevronDown: FC<Props> = ({ className, ...props }) => (
  <svg
    className={classNames('w-[24px] h-[24px] stroke-[2px]', className)}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6 9.00012L12 15.0001L18 9.00012"
      stroke="currentColor"
      strokeWidth="currentStrokWidth"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ChevronDown;
